import { render, staticRenderFns } from "./orgitemview.vue?vue&type=template&id=0d568cc2"
import script from "./orgitemview.vue?vue&type=script&lang=js"
export * from "./orgitemview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports